module.exports = __webpack_public_path__ + "img/solutions_s3d_1.5b60fc51.png";